import axios from "axios"

export default {
    state: {
        courseBeginners: [],
        courseElementaries: [],
        courseIntermediates: [],
        courseUpperIntermediates: [],
        course: null
    },
    getters: {
        courseBeginners(state) {
            return state.courseBeginners;
        },
        courseElementaries(state) {
            return state.courseElementaries;
        },
        courseIntermediates(state) {
            return state.courseIntermediates;
        },
        courseUpperIntermediates(state) {
            return state.courseUpperIntermediates;
        },
        course(state) {
            return state.course;
        }
    },
    mutations: {
        setCourseBeginners(state, courseBeginners) {
            state.courseBeginners = courseBeginners;
        },
        setCourseElementaries(state, courseElementaries) {
            state.courseElementaries = courseElementaries;
        },
        setCourseIntermediates(state, courseIntermediates) {
            state.courseIntermediates = courseIntermediates;
        },
        setCourseUpperIntermediates(state, courseUpperIntermediates) {
            state.courseUpperIntermediates = courseUpperIntermediates;
        },
        setCourse(state, course) {
            state.course = course;
        }
    },
    actions: {
        async getCourseBeginners({ commit }) {
            let res = await axios.get(`/course/1`);
            let courseBeginners = res.data.data;
            commit('setCourseBeginners', courseBeginners)
        },
        async getCourseElementaries({ commit }) {
            let res = await axios.get(`/course/2`);
            let courseElementaries = res.data.data;
            commit('setCourseElementaries', courseElementaries)
        },
        async getCourseIntermediates({ commit }) {
            let res = await axios.get(`/course/3`);
            let courseIntermediates = res.data.data;
            commit('setCourseIntermediates', courseIntermediates)
        },
        async getCourseUpperIntermediates({ commit }) {
            let res = await axios.get(`/course/4`);
            let courseUpperIntermediates = res.data.data;
            commit('setCourseUpperIntermediates', courseUpperIntermediates)
        },
        async getCourseDetail({ commit }, id) {
            let res = await axios.get(`/courses/${id}`);
            let course = res.data.data;
            commit('setCourse', course)
        },
    }
}